module.exports = {"610115001":"骊山街道","610115002":"秦陵街道","610115003":"新丰街道","610115004":"代王街道","610115005":"斜口街道","610115006":"行者街道","610115007":"零口街道","610115008":"相桥街道","610115009":"雨金街道","610115010":"新市街道","610115011":"徐杨街道","610115012":"西泉街道","610115013":"栎阳街道","610115014":"马额街道","610115015":"何寨街道","610115016":"交口街道","610115017":"油槐街道","610115018":"北田街道","610115019":"铁炉街道","610115020":"任留街道","610115021":"穆寨街道","610115022":"小金街道","610115023":"仁宗街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610115.json
// module id = 2783
// module chunks = 0